export default __webpack_public_path__ + "static/media/screenshot_org_report_desktop_purple.0bea258e.png";